import { useTreatmentServiceGetConsultationDiagnosesEndpoint } from 'src/api/queries'

/** The person's current diagnoses: the newest consultation that recorded
 *  a diagnosis (`primary`, with `primaryDiagnostics`) and the newest that
 *  recorded final ones. A consultation records a single diagnosis (the final
 *  one); older consultations may only have preliminary diagnoses, which are
 *  used for `primaryDiagnostics` when there is no final one.
 *  Follow-up visits without diagnoses are skipped. */
export const useLatestConsultationDiagnoses = (
  personId?: string,
  enabled = true
) => {
  const { data, isLoading } =
    useTreatmentServiceGetConsultationDiagnosesEndpoint(
      { personId: String(personId), pageNumber: 1, pageSize: 50 },
      ['latest', personId],
      { enabled: enabled && !!personId, retry: false }
    )

  const items = data?.data ?? []

  const primary = items.find(
    (item) =>
      !!item.finalDiagnostics?.length || !!item.preliminaryDiagnostics?.length
  )

  return {
    primary,
    primaryDiagnostics: primary?.finalDiagnostics?.length
      ? primary.finalDiagnostics
      : primary?.preliminaryDiagnostics,
    final: items.find((item) => !!item.finalDiagnostics?.length),
    isLoading,
    isLoaded: !!data
  }
}
